module.exports = __webpack_public_path__ + "img/confirm.3b3aaca1.svg";